import React, { Component } from "react";
import { connect } from "react-redux";
import BusinessReport from "./BusinessReport";

import { Layout, Breadcrumb } from "antd";
const { Content } = Layout;

class Dashboard extends Component {
  render() {
    return (
      <>
        <Breadcrumb style={{ margin: "16px 0" }}>
          <Breadcrumb.Item>Business report</Breadcrumb.Item>
        </Breadcrumb>
        <div className="site-layout-background main-frame">
          <BusinessReport />
        </div>
      </>
    );
  }
}

export default connect()(Dashboard);
